import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { FloorPlansFeatureService } from '../services/floor-plans-feature.service';

export const floorPlansFeatureGuard: CanActivateFn = (route) => {
  const floorPlansFeatureService = inject(FloorPlansFeatureService);
  const router = inject(Router);

  if (floorPlansFeatureService.isVisible()) {
    return true;
  }

  const workspaceId = route.paramMap.get('workspaceId');
  const folderId = route.paramMap.get('folderId');
  const inspectionId = route.paramMap.get('inspectionId');

  return router.createUrlTree(['/workspace', workspaceId, 'folders', folderId, 'inspections', inspectionId, 'overview']);
};
